import { generateEndpointApi, methods } from '@btime/react-api'

export const listLogsEndpoint = generateEndpointApi('list', methods.GET, {
  apiUrl: process.env.REACT_APP_LOG_API_URL
})
